"use client";

/**
 * useMediaQuery
 * @description 미디어 쿼리의 현재 값. 서버와 첫 클라이언트 렌더에서는 `false` 다 — 화면 폭을
 *   서버가 알 수 없어서, 값이 갈리는 것은 붙은 뒤에만 그린다(오버레이처럼 처음엔 닫혀 있는
 *   것들이 쓴다).
 * @example
 * const isTablet = useMediaQuery(TABLET_QUERY);
 */
import { useEffect, useState } from "react";

/** `globals.css` 의 `--breakpoint-tablet` 과 같은 값 */
export const TABLET_QUERY = "(min-width: 768px)";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);

  return matches;
}
